/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */
import {css} from 'lit';
export const styles = css`:host{display:block}:host([seperator]) .mdc-tab-bar mwc-tab-scroller ::slotted(fds-tab:not([active]):not(:first-child))::before{content:"";display:block;position:absolute;top:12px;bottom:12px;width:1px;margin-left:4px;background:var(--fds-outline, rgba(0, 0, 0, 0.12))}`;
